/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { classnames } from "../../utils/text";

const Counter = ({ field, data, className, min, max = 100, step = 1, disabled }) => {
  const [inputValue, setInputValue] = useState(data);

  useEffect(() => {
    const dataSet = {
      [field.key || "counter"]: inputValue,
    };

    field.handleChange(dataSet, field);

  }, [inputValue, data]);

  return (
    <>
      <div className={classnames("custom-counter-component", className)}>
        {field.label && (
          <div className="counter-label-wrap">
            <span className="counter-label">{field.label}</span>
          </div>
        )}
        <div className="counter-input-wrap">
          <input
            name={field.key}
            value={`${inputValue}${field.unit}`}
            className="counter-input"
            readOnly
          />
        </div>
        <div className="control-button-wrap">
          <button
            className="control-button up"
            onClick={() => {
              if (inputValue === max) return;
              setInputValue(inputValue + step);
            }}
            disabled={disabled}
          ></button>
          <button
            className="control-button down"
            onClick={() => {
              if (inputValue === min) return;
              setInputValue(inputValue - step);
            }}
            disabled={disabled}
          ></button>
        </div>
      </div>
    </>
  );
};

export default Counter;
